import * as angular from "angular";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { CustomFieldAttachmentModel } from "../../models/custom-field-attachment.model";
import { HouseOccupant } from "../../models/house-occupant.model";

let ViewMultipleCustomFieldAttachmentsComponent = {
    selector: "vcViewMultipleCustomFieldAttachments",
    templateUrl:
        "/angular/components/custom-fields/view-multiple-custom-field-attachments.component.html",
    bindings: {
        houseoccupant: "=",
        cfid: "=",
    },
    controller: class ViewMultipleCustomFieldAttachments {
        // * bindings for typescript compiler *
        public houseoccupant: HouseOccupant;
        public cfid: number;
        // ************************************

        public $scope: any;
        public dialog: DialogUtils;
        public dataProvider: FieldDataProvider;
        public files: any[];

        constructor(
            $scope: any,
            FieldDataProvider: FieldDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.dataProvider = FieldDataProvider;
        }

        $onInit() {
            this.dataProvider
                .getMultipleAttachments({
                    hoid:
                        this.houseoccupant.houseoccupantid ??
                        this.houseoccupant.hoid,
                    cfid: this.cfid,
                })
                .then((data: any) => {
                    this.files = data;
                });
        }

        viewCustomFieldAttachment(
            file: CustomFieldAttachmentModel,
            ev: any
        ): void {
            this.dialog.show({
                component: "vc-view-custom-field-attachment",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "x-large",
                locals: {
                    file: file,
                },
            });
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("customField")
    .component(
        ViewMultipleCustomFieldAttachmentsComponent.selector,
        ViewMultipleCustomFieldAttachmentsComponent
    );
